<template>
  <div class="footer">
    <a class="link" href="/contract/policy.html" rel="external nofollow"  target="_blank">Privacy policy</a>
    <strong></strong>
    <a class="link" href="/contract/terms.html" rel="external nofollow"  target="_blank">Terms of service</a>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
.footer{
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: .8rem;
  padding: 0 .4rem;
  .link{
    line-height: .8rem;
    font-size: .16rem;
    text-decoration: none;
    color: #00000066;
  }
  strong{
    width: .04rem;
    height: .04rem;
    border-radius: .04rem;
    background-color: #00000066;
    margin: 0 .08rem;
  }
}
</style>
